// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as PorterStoreTypes from "./PorterStoreTypes.bs.js";

var clickOutsideHandler = (function(ref, setState) {
    function handleClick(e) {
      var el = ref.current;
      if (el && !el.contains(e.target)) {
        setState(function() { return false; });
      }
    }
    document.addEventListener("mousedown", handleClick);
    return function() { document.removeEventListener("mousedown", handleClick); };
  });

function escapeCsvField(field) {
  if (field.includes(",") || field.includes("\"") || field.includes("\n")) {
    return "\"" + field.replace(/"/g, "\"\"") + "\"";
  } else {
    return field;
  }
}

function generateCsv(orders) {
  var rows = Belt_Array.map(orders, (function (order) {
          return Belt_Array.map([
                        order.orderId,
                        order.createdOn,
                        PorterStoreTypes.orderStatusToString(order.orderStatus),
                        order.partnerName,
                        order.city,
                        order.phoneNumber,
                        order.accessedAt
                      ], escapeCsvField).join(",");
        }));
  return "Order ID,Order Timestamp,Order Status,Partner Name,City,Phone Number,Accessed Timestamp\n" + rows.join("\n");
}

var triggerDownload = (function(csvContent) {
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "porter_store_in_progress.csv");
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  });

function downloadCsv(orders) {
  return triggerDownload(generateCsv(orders));
}

function filterOrders(orders, selectedStatuses, selectedCities) {
  return Belt_Array.keep(orders, (function (order) {
                var matchesStatus = selectedStatuses.length === 0 || Belt_Array.some(selectedStatuses, (function (s) {
                        return s === order.orderStatus;
                      }));
                var matchesCities = selectedCities.length === 0 || Belt_Array.some(selectedCities, (function (c) {
                        return c === order.city;
                      }));
                if (matchesStatus) {
                  return matchesCities;
                } else {
                  return false;
                }
              }));
}

export {
  clickOutsideHandler ,
  escapeCsvField ,
  generateCsv ,
  triggerDownload ,
  downloadCsv ,
  filterOrders ,
  
}
/* No side effect */
